export default {
  'completeprofile.completeprofile': 'SATRT COMPLETE PROFILE PROCESS',
  'completeprofile.maintext':
    'To complete your profile items and gets positive points please try to complete  your profile by pressing Complete Profile',
};
